import "core-js/modules/es.array.push.js";
import axios from "axios";
import router from "../router/router";
import notify from "devextreme/ui/notify";
const requestAxios = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.VUE_APP_API_ROOT
});
async function handleAuthorizationError(error) {
  const origialRequest = error.config;
  const securityStore = useSecurityStore();
  const refreshToken = securityStore.refreshToken;
  if (!origialRequest._retry) {
    origialRequest._retry = true;
    try {
      await securityStore.issueNewToken(refreshToken);
      origialRequest.headers.Authorization = "Bearer " + securityStore.token;
      return new Promise(resolve => resolve(requestAxios(origialRequest, securityStore.token)));
    } catch (tokenError) {
      securityStore.destroyJwtData();
      router.push("/login-form");
      return new Promise.reject(tokenError);
    }
  }
}
requestAxios.interceptors.response.use(null, error => {
  if (error.response?.status === 401 && !error._retry) {
    return handleAuthorizationError(error);
  } else if (error.response?.status === 413) {
    notify("Notify.FileDownloadError", "error", 2000);
  }
  return Promise.reject(error);
});
requestAxios.interceptors.request.use(config => {
  if (!config.headers.Authorization) {
    const securityStore = useSecurityStore();
    const token = securityStore.token;
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
  }
  return config;
}, error => Promise.reject(error));
export default requestAxios;